export const defData = {
  corpus:
    'Nzɔ de’áxa Tsənaxa, ño lo sɛtsa’ɔk, ño lo de’áxa u Kasaga, ño lo mɛya ayru Tol o Əbe kwə, sa nzɔ xa mpaskale: Steyə rabɛ lu ñire lu mvunə poxe o lu pɛlɔ ah lo mɛwɛ axe, maxə ɔra latsi əbɔwə səyo.',
  consonants:
    'b/d/f/g/k/kw/l/m/mp/mv/n/nt/nts/nz/ñ/ŋk/ŋkw/p/r/s/t/ts/v/w/x,h/y/’',
  vowels: 'a,á/ɛ,ɛ́/e,é/ə,ə́/i,í/ɔ,ɔ́/o,ó/u,ú',
  distinguishCase: false,
  analyzed: false,
  results: undefined,
  hovered: undefined,
  filterSeg: 'all',
  filterSyll: 'all',
  filterWords: 'all'
}
